//@ts-ignore
import {createApp, defineComponent, h, nextTick} from "vue";

export class VueComponentControl implements mapboxgl.IControl {
  private _componentInstance;
  private localApp;
  private enclosure;
  private controlId;

  constructor(private component, private properties: any = {}) {
  }

  getDefaultPosition(): string {
    return "";
  }

  onAdd(map: mapboxgl.Map): HTMLElement {
    this.enclosure = document.createElement('div');
    this.enclosure.classList.add('mapToolbox');
    this.enclosure.classList.add('mapboxgl-ctrl');
    this.controlId = this.properties?.id;
    nextTick(() => {
      this.createComponent({
        component: this.component,
        props: {...this.properties, mapController: map._controller},
        el: this.enclosure
      })
    }).then(() => {
    });

    return this.enclosure;
  }

  onRemove(map: mapboxgl.Map): void {
    if (this.localApp) {
      this.localApp.unmount();
      this.localApp = null;
    }

    if (this.enclosure && this.enclosure.parentNode) {
      this.enclosure.parentNode.removeChild(this.enclosure);
      this.enclosure = null;
    }
  }

  toggle(show: Boolean): void {
    if (show)
      this._componentInstance.$el.parentNode.style.display = ''
    else
      this._componentInstance.$el.parentNode.style.display = 'none'
  }

  setVisibility(visibility: boolean) {
    if (this._componentInstance) {
      this._componentInstance.visibility = visibility;
      //this._componentInstance.updateVisibility(true);
    }
  }

  setActive(active: boolean) {
    if (this._componentInstance) {
      this._componentInstance.active = active;
      this._componentInstance.updateVisibility(true);
    }
  }

  forceUpdate() {
    if (this._componentInstance) {
      this._componentInstance.$forceUpdate();
    }
  }

  createComponent({component, props, el}) {

    let app = (window as any).mainApp;

    let expose = null

    const childApp = createApp({render: () => expose = h(component, props)})

    Object.assign(childApp._context, app._context)
    this.localApp = childApp;

    this._componentInstance = childApp.mount(el);

    if(this.properties?.isHidden) this.toggle(!this.properties?.isHidden)

    return expose.component.exposed
  }

}
